import * as React from "react";
import { cn } from "./utils";
import { ArrowDown, ArrowUp } from "lucide-react";

export interface FormScoringBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    scoring?: string | null;
}

const FormScoringBadge = React.forwardRef<HTMLSpanElement, FormScoringBadgeProps>(
    ({ className, scoring, ...props }, ref) => {
        if (!scoring) return null;

        const isHigher = scoring.toLowerCase().includes("higher");
        const isLower = scoring.toLowerCase().includes("lower");

        if (!isHigher && !isLower) {
            return (
                <span
                    ref={ref}
                    className={cn(
                        "inline-flex items-center bg-indigo-100 shadow-sm px-2 py-1 border border-indigo-200 rounded-md font-semibold text-indigo-800 text-xs capitalize",
                        className
                    )}
                    {...props}
                >
                    {scoring.replace(/_/g, " ")}
                </span>
            );
        }

        return (
            <span
                ref={ref}
                className={cn(
                    "inline-flex items-center gap-1 shadow-sm px-2 py-1 border rounded-md font-semibold text-xs",
                    isHigher
                        ? "bg-green-100 text-green-800 border-green-200"
                        : "bg-yellow-100 text-yellow-800 border-yellow-200",
                    className
                )}
                {...props}
            >
                {isHigher ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />}
                <span>{isHigher ? "Higher is better" : "Lower is better"}</span>
            </span>
        );
    }
);

FormScoringBadge.displayName = "FormScoringBadge";

export { FormScoringBadge };
